module.exports = __webpack_public_path__ + "static/media/sample_mll_destination_yard.92809b16.csv";